// extracted by mini-css-extract-plugin
export var list = "trening-switcher-module--list--CYI8p";
export var listActiveItem = "trening-switcher-module--list-active-item--WFA-Q";
export var listItem = "trening-switcher-module--list-item--p5sAh";
export var scaling = "trening-switcher-module--scaling--dOCQt";
export var underLine = "trening-switcher-module--under-line--Hsduk";